import React from "react";
import styled from "@emotion/styled";
import { PatientDocumentPOCItem, POCItemsDocumentAnswer } from "../../messages/PatientDocuments";
import { POCItemHeader } from "./POCItemHeader";
import { POCItemTaskBody } from "./POCItemTaskBody";

interface POCItemProps {
  item: PatientDocumentPOCItem;
  index: number;
  currentAnswer: POCItemsDocumentAnswer[] | null;
  isRequired: boolean;
  readonly: boolean;
  onTaskCheck: (index: number) => void;
  onWhenToPerformChange: (index: number, whenToPerform: any) => void;
  onFrequencyChange: (
    index: number,
    frequency: number | null,
    visitsInAWeek: number | null
  ) => void;
  onNotesChange: (index: number, notes: string) => void;
}

export function POCItem({
  item,
  index,
  currentAnswer,
  isRequired,
  readonly,
  onTaskCheck,
  onWhenToPerformChange,
  onFrequencyChange,
  onNotesChange,
}: POCItemProps) {
  if (item.isTitle) {
    return <SectionName key={index}>{item.name}</SectionName>;
  }

  const isChecked = currentAnswer?.some((answer) => answer.idx === index) ?? false;
  const currentItemAnswer = currentAnswer?.find((answer) => answer.idx === index);

  return (
    <ItemContainer key={index}>
      <POCItemHeader
        item={item}
        index={index}
        isChecked={isChecked}
        isRequired={isRequired}
        readonly={readonly}
        onTaskCheck={onTaskCheck}
      />
      {isChecked && (
        <POCItemTaskBody
          index={index}
          currentAnswer={currentItemAnswer}
          readonly={readonly}
          onWhenToPerformChange={onWhenToPerformChange}
          onFrequencyChange={onFrequencyChange}
          onNotesChange={onNotesChange}
        />
      )}
    </ItemContainer>
  );
}

const ItemContainer = styled.div`
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0px 4px 16px rgba(123, 130, 141, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  color: #283847;
  font-size: 15px;
`;

const SectionName = styled.div`
  margin: 0 20px;
  color: #7b828d;
  font-weight: bold;
  font-size: 15px;
`;
